module.exports = __webpack_public_path__ + "static/media/mountains.e57148ad.png";